export default __webpack_public_path__ + "assets/webgl/complete-1.954deae6.jpg";